import {
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import React from "react";
import { COLORS, getSummaryTableColumns, TABLE_TYPE } from "../conciliacaoUtil";
import ConciliationSummaryTableRowCell from "./conciliationSummaryTableRowCell";
import ConciliationTableHeaderCell from "./conciliationTableHeaderCell";

export const ConciliationSummaryTable = ({ classes, summary, pageType }) => {
  const { t } = useTranslations();
  const tableColumns = getSummaryTableColumns(t);

  return (
    <>
      <Typography
        id="summary-table-title"
        className={classes.title}
        gutterBottom
      >
        {t("common:summary")}
      </Typography>
      {summary != null && (
        <Paper className={classes.containerTable}>
          <Table id="summary-table" className={classes.table}>
            <colgroup>
              {tableColumns.map((col) => (
                <col
                  key={`summary-col-${col.id}-width`}
                  style={{ width: "9%" }}
                />
              ))}
            </colgroup>

            <TableHead id="summary-table-header">
              <TableRow style={{ backgroundColor: COLORS.GRAY }}>
                {tableColumns.map((column) => (
                  <ConciliationTableHeaderCell
                    columnId={column.id}
                    key={`summary-header-${column.id}`}
                    label={column.label}
                    pageType={pageType}
                    tableType={TABLE_TYPE.SUMMARY}
                  />
                ))}
              </TableRow>
            </TableHead>
            <TableBody key="summary-table-body" id="summary-table-body">
              <TableRow
                key="summary-table-body-row"
                id="summary-table-body-row"
                style={{ backgroundColor: COLORS.VERY_LIGHT_GRAY }}
              >
                {tableColumns.map((column) => (
                  <ConciliationSummaryTableRowCell
                    appValue={summary[0][column.field]}
                    columnId={column.id}
                    key={`summary-column-cell-${column.id}`}
                    pageType={pageType}
                    portalValue={summary[1][column.field]}
                  />
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      )}
    </>
  );
};

const styles = {
  typography: {
    fontFamily: "Roboto",
  },
  title: {
    fontSize: "16px",
    fontWeight: "500",
    fontFamily: "Roboto",
    color: "#424242",
    marginBottom: "20px",
    textTransform: "uppercase",
  },
  containerTable: {
    borderRadius: "16px",
  },
  table: {
    width: "100%",
    marginTop: "25px",
    marginBottom: "25px",
    fontFamily: "Roboto",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "1px",
    borderRadius: "0 0 16px 16px",
  },
};

export default withStyles(styles)(ConciliationSummaryTable);
